<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "ButtonCloseFilter",
    props: {
        text: {
            type: String,
            required: true
        }
    }
});
</script>

<template>
    <button class="ButtonBase ButtonBase--primary ButtonCloseFilter">
        <span>{{ text }}</span>
    </button>
</template>